import React from 'react';

export default function EmailSnippetRenderer({ question, value, onChange }) {
  if (!question) return null;

  const optionEntries = Array.isArray(question.options)
    ? question.options.map((opt) => [opt.key, opt.text])
    : Object.entries(question.options || {});

  const email = question.emailSnippet || {};

  return (
    <div>
      <div className="rounded-2xl bg-white text-slate-900 border border-slate-200 p-5 shadow-sm">
        <div className="text-xs md:text-sm space-y-1 border-b border-slate-200 pb-3">
          <p><span className="font-semibold">From:</span> {email.from || 'manager@company.example'}</p>
          <p><span className="font-semibold">To:</span> {email.to || 'team@company.example'}</p>
          <p><span className="font-semibold">Subject:</span> {email.subject || 'Project Update'}</p>
        </div>
        <p className="mt-4 text-sm leading-6 whitespace-pre-wrap">{email.body || question.question}</p>
      </div>

      <div className="mt-4 rounded-2xl border border-white/20 bg-slate-900/55 backdrop-blur-xl p-5">
        <p className="text-lg leading-8 font-jakarta text-white">{question.prompt || question.question}</p>
      </div>

      <div className="mt-4 space-y-3">
        {optionEntries.map(([key, text]) => {
          const selected = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition ${selected ? 'border-emerald-300 bg-gradient-to-r from-emerald-500 to-teal-600 text-white' : 'border-white/25 bg-slate-800/60 text-white hover:border-emerald-400/70 hover:bg-slate-700/70'}`}
            >
              <span className="font-semibold mr-2">{key}.</span>
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
